unit JobErrorForm;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Data.DB,
  WEBLib.CDS,
  WEBLib.DB,
  WEBLib.Grids,
  WEBLib.DBCtrls, WEBLib.REST;

type
  TJobErrors = class(TCoreWebForm)
    ErrorDataSet: TClientDataSet;
    ErrorConnection: TClientConnection;
    JobSource: TDataSource;
    ErrorDataSetkey: TStringField;
    ErrorDataSetvalue: TStringField;
    ErrorDataSeterror: TStringField;
    WebDBTableControl1: TDBTableControl;
    ErrorSource: TDataSource;
    JobErrorCloseButton: TButton;
    procedure JobErrorCloseButtonClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
  private
    procedure ShowEmptyState(AEmpty: Boolean);
  public
    procedure ShowNoErrorFile;
    [async]
    procedure LoadJobErrors(AJobId: Integer); async;
  protected procedure LoadDFMValues; override; end;

implementation

uses
  MainDataModule,
  XData.Web.Client,
  SMX.Web.Service.Consts;

{$R *.dfm}

procedure TJobErrors.WebFormCreate(Sender: TObject);
begin
  inherited;
  ElementClassName := 'PopUpForm job-errors-popup';
  if Assigned(WebDBTableControl1) then
  begin
    WebDBTableControl1.ElementID := 'JobErrorsTableHost';
    WebDBTableControl1.ElementPosition := epIgnore;
    WebDBTableControl1.HeightStyle := ssAuto;
    WebDBTableControl1.WidthStyle := ssAuto;
  end;
end;

procedure TJobErrors.JobErrorCloseButtonClick(Sender: TObject);
begin
  ModalResult := mrClose;
end;

procedure TJobErrors.ShowEmptyState(AEmpty: Boolean);
var
  lEl: TJSHTMLElement;
begin
  if Assigned(WebDBTableControl1) then
    WebDBTableControl1.Visible := not AEmpty;

  lEl := TJSHTMLElement(document.getElementById('JobErrorsEmptyMsg'));
  if Assigned(lEl) then
  begin
    if AEmpty then
      lEl.style.setProperty('display', '')
    else
      lEl.style.setProperty('display', 'none');
  end;
end;

procedure TJobErrors.ShowNoErrorFile;
begin
  ErrorDataSet.Close;
  ErrorConnection.Active := False;
  ErrorDataSet.Connection := nil;
  ErrorDataSet.Rows := TJSArray.new;
  ErrorDataSet.Open;
  ShowEmptyState(True);
end;

procedure TJobErrors.LoadJobErrors(AJobId: Integer);
var
  lRetval: TXDataClientResponse;
  lErrorJson: string;
  lArr: TJSArray;
begin
  ErrorDataSet.Close;
  ErrorConnection.Active := False;
  ErrorDataSet.Connection := nil;

  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(IJOBSVC_GETERRORFILE, [AJobId]));

  if not Assigned(lRetval) or not Assigned(lRetval.ResultAsObject) then
    raise Exception.Create('No response from GetErrorFile');

  lErrorJson := '';
  if lRetval.ResultAsObject.hasOwnProperty('value') then
    lErrorJson := JS.toString(lRetval.ResultAsObject['value']);

  if Trim(lErrorJson) = '' then
    lArr := TJSArray.new
  else
  begin
    lArr := TJSArray(TJSJSON.parse(lErrorJson));
    if lArr = nil then
      lArr := TJSArray.new;
  end;

  ErrorDataSet.Rows := lArr;
  ErrorDataSet.Open;
  ShowEmptyState(lArr.Length = 0);
end;

procedure TJobErrors.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebDBTableControl1 := TDBTableControl.Create('JobErrorsTableHost');
  JobErrorCloseButton := TButton.Create('JobErrorCloseButton');
  ErrorDataSet := TClientDataSet.Create(Self);
  ErrorDataSetkey := TStringField.Create(Self);
  ErrorDataSetvalue := TStringField.Create(Self);
  ErrorDataSeterror := TStringField.Create(Self);
  ErrorConnection := TClientConnection.Create(Self);
  JobSource := TDataSource.Create(Self);
  ErrorSource := TDataSource.Create(Self);

  WebDBTableControl1.BeforeLoadDFMValues;
  JobErrorCloseButton.BeforeLoadDFMValues;
  ErrorDataSet.BeforeLoadDFMValues;
  ErrorDataSetkey.BeforeLoadDFMValues;
  ErrorDataSetvalue.BeforeLoadDFMValues;
  ErrorDataSeterror.BeforeLoadDFMValues;
  ErrorConnection.BeforeLoadDFMValues;
  JobSource.BeforeLoadDFMValues;
  ErrorSource.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 96;
    WebDBTableControl1.Top := 144;
    WebDBTableControl1.Width := 425;
    WebDBTableControl1.Height := 200;
    WebDBTableControl1.HeightStyle := ssAuto;
    WebDBTableControl1.WidthStyle := ssAuto;
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ChildOrder := 1;
    WebDBTableControl1.ElementFont := efCSS;
    WebDBTableControl1.ElementHeaderClassName := 'thead-light';
    WebDBTableControl1.ElementPosition := epIgnore;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover';
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'key';
      Title := 'Key';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'value';
      Title := 'Value';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'error';
      Title := 'Error';
    end;
    WebDBTableControl1.DataSource := ErrorSource;
    JobErrorCloseButton.SetParentComponent(Self);
    JobErrorCloseButton.Name := 'JobErrorCloseButton';
    JobErrorCloseButton.Left := 496;
    JobErrorCloseButton.Top := 424;
    JobErrorCloseButton.Width := 96;
    JobErrorCloseButton.Height := 25;
    JobErrorCloseButton.Caption := 'Close';
    JobErrorCloseButton.ChildOrder := 2;
    JobErrorCloseButton.ElementClassName := 'btn btn-secondary';
    JobErrorCloseButton.ElementFont := efCSS;
    JobErrorCloseButton.ElementPosition := epIgnore;
    JobErrorCloseButton.HeightStyle := ssAuto;
    JobErrorCloseButton.HeightPercent := 100.000000000000000000;
    JobErrorCloseButton.WidthStyle := ssAuto;
    JobErrorCloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(JobErrorCloseButton, Self, 'OnClick', 'JobErrorCloseButtonClick');
    ErrorDataSet.SetParentComponent(Self);
    ErrorDataSet.Name := 'ErrorDataSet';
    ErrorDataSet.Left := 65;
    ErrorDataSet.Top := 96;
    ErrorDataSetkey.SetParentComponent(ErrorDataSet);
    ErrorDataSetkey.Name := 'ErrorDataSetkey';
    ErrorDataSetkey.FieldName := 'key';
    ErrorDataSetkey.Size := 64;
    ErrorDataSetvalue.SetParentComponent(ErrorDataSet);
    ErrorDataSetvalue.Name := 'ErrorDataSetvalue';
    ErrorDataSetvalue.FieldName := 'value';
    ErrorDataSetvalue.Size := 64;
    ErrorDataSeterror.SetParentComponent(ErrorDataSet);
    ErrorDataSeterror.Name := 'ErrorDataSeterror';
    ErrorDataSeterror.FieldName := 'error';
    ErrorDataSeterror.Size := 512;
    ErrorConnection.SetParentComponent(Self);
    ErrorConnection.Name := 'ErrorConnection';
    ErrorConnection.Active := False;
    ErrorConnection.DataNode := 'value';
    ErrorConnection.Delimiter := ';';
    ErrorConnection.Left := 64;
    ErrorConnection.Top := 32;
    JobSource.SetParentComponent(Self);
    JobSource.Name := 'JobSource';
    JobSource.Left := 184;
    JobSource.Top := 32;
    ErrorSource.SetParentComponent(Self);
    ErrorSource.Name := 'ErrorSource';
    ErrorSource.DataSet := ErrorDataSet;
    ErrorSource.Left := 144;
    ErrorSource.Top := 88;
  finally
    WebDBTableControl1.AfterLoadDFMValues;
    JobErrorCloseButton.AfterLoadDFMValues;
    ErrorDataSet.AfterLoadDFMValues;
    ErrorDataSetkey.AfterLoadDFMValues;
    ErrorDataSetvalue.AfterLoadDFMValues;
    ErrorDataSeterror.AfterLoadDFMValues;
    ErrorConnection.AfterLoadDFMValues;
    JobSource.AfterLoadDFMValues;
    ErrorSource.AfterLoadDFMValues;
  end;
end;

end.
